import { PathSpec } from '@/types';

export const pathSpecKey = (pathSpec: PathSpec | undefined) => {
  if (!pathSpec) return null;
  return JSON.stringify({
    segments: pathSpec.segments.map((segment) => ({
      r_point_id: segment.r_point_id,
      d_point_id: segment.d_point_id,
      contract_spec: {
        type: segment.contract_spec.type,
        contract_id:
          segment.contract_spec.type === 'exact'
            ? segment.contract_spec.contract_id
            : null,
      },
    })),
    buy_price_definition: pathSpec.buy_price_definition ?? null,
    sell_price_definition: pathSpec.sell_price_definition ?? null,
  });
};

export const pathSpecsEqual = (
  left: PathSpec | undefined,
  right: PathSpec | undefined,
) => pathSpecKey(left) !== null && pathSpecKey(left) === pathSpecKey(right);